// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-cd83a5b2] .selectize-input {\n  background: #5b6064;\n  border-color: #303337;\n}\n.disabled-text[data-v-cd83a5b2] {\n  opacity: .2;\n}\n[data-v-cd83a5b2] input[disabled=\"disabled\"] ~ label:after {\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
